import React, { useEffect, useMemo, useCallback } from 'react';
import { connect } from 'react-redux';
// import moment from 'moment';
import TeamMembershipTableCell from './TeamMembershipTableCell';
import Loader from '../general/Loader';
import SkillIconList from '../general/SkillIconList';
import { IconShuffle } from '../ui-kit/icons';
import { useWindowDimensions } from '../../utils/custom-hooks';
import { Table, Badge, Button /*, Dropdown, Modal, Form */ } from '../ui-kit';
// import DateTimePicker from '../general/DateTimePicker';
import { operations as membershipOperations, selectors as membershipSelectors } from '../../state/modules/memberships';
import { operations as userOperations, selectors as userSelectors } from '../../state/modules/users';
import { operations as groupOperations, selectors as groupSelectors } from '../../state/modules/groups';
import {
  operations as activePeriodOperations,
  selectors as activePeriodSelectors
} from '../../state/modules/active-periods';
import { operations as skillOperations } from '../../state/modules/skills';
import '../skills/SkillEditTable.css';

// NOTE: all commented out code is for the context menu and assign/revoke
// dialog, which are not currently used in this component. This is similar to
// the SkillEditTable component, which has the same functionality for skills
// instead of teams.
// We do not want to expose the functionality yet to historically edit team
// memberships before discussing with the team, so we are leaving it commented
// out for now.

// const ASSIGN = 'assign';
// const REVOKE = 'revoke';
const emptyObject = {};
const emptyArray = [];

// const AssignRevokeDialog = ({ type, onCancel, onSubmit, userName, teamName }) => {
//   const show = !!type;
//   const [time, setTime] = useState(null);
//   const [comments, setComments] = useState('');
//
//   useEffect(() => {
//     if (!show) return;
//     setTime(moment().startOf('day').format());
//     setComments('');
//   }, [show]);
//
//   if (!show) return null;
//
//   const label =
//     type === REVOKE
//       ? I18n.t('activerecord.attributes.certification.end_time')
//       : I18n.t('activerecord.attributes.certification.start_time');
//
//   const titleI18nKey =
//     type === REVOKE ? 'team_memberships.dialog.title.revoke' : 'team_memberships.dialog.title.assign';
//   const title = I18n.t(titleI18nKey, {
//     team_name: teamName,
//     user_name: userName
//   });
//
//   return (
//     <Modal show={show} onHide={onCancel}>
//       <Modal.Header closeButton>
//         <Modal.Title>{title}</Modal.Title>
//       </Modal.Header>
//       <Modal.Body>
//         <Form>
//           <Form.Group controlId="startTime">
//             <Form.Label column sm={3}>
//               {label}
//             </Form.Label>
//             <DateTimePicker name="startTime" value={time} onChange={setTime} customLabel={label} />
//           </Form.Group>
//         </Form>
//         <Form.Group controlId="comments" className="mt-3">
//           <Form.Label column sm={3}>
//             {I18n.t('comments')}
//           </Form.Label>
//           <Form.Control as="textarea" rows={3} value={comments} onChange={e => setComments(e.target.value)} />
//         </Form.Group>
//       </Modal.Body>
//       <Modal.Footer>
//         <Button variant="secondary" onClick={onCancel}>
//           {I18n.t('cancel')}
//         </Button>
//         <Button variant={type == REVOKE ? 'danger' : 'primary'} onClick={() => onSubmit(time, comments)}>
//           {I18n.t('save')}
//         </Button>
//       </Modal.Footer>
//     </Modal>
//   );
// };

// const ContextMenu = ({ show, xCoord, yCoord, showDialog }) => (
//   <Dropdown.ContextMenu x={xCoord} y={yCoord} show={show}>
//     <Dropdown.Item onClick={() => showDialog(ASSIGN)}>
//       {I18n.t('team_memberships.context_menu.assign_team_at')}
//     </Dropdown.Item>
//     <Dropdown.Item onClick={() => showDialog(REVOKE)}>
//       {I18n.t('team_memberships.context_menu.revoke_team_at')}
//     </Dropdown.Item>
//   </Dropdown.ContextMenu>
// );

const TeamMembershipEditTable = ({
  groupId,
  readonly,
  teamExchangeEnabled,
  fetchMemberships,
  fetchSkills,
  fetchUsers,
  fetchGroups,
  fetchActivePeriods,
  assignTeamMembership,
  memberships,
  groups,
  usersById,
  activePeriodsByUserAndGroupId,
  loaded
}) => {
  // const [showContextMenu, setShowContextMenu] = useState({
  //   xCoord: null,
  //   yCoord: null,
  //   show: false,
  //   teamId: null,
  //   userId: null
  // });
  // const [showDialogType, setShowDialogType] = useState(null);

  useEffect(() => {
    fetchGroups({ params: { group_ids: groupId, in_hierarchy: true } });
    fetchMemberships({ params: { group_ids: groupId }, forceFetch: true });
    fetchSkills({ params: { group_ids: groupId } });
    fetchUsers({ params: { group_ids: groupId, presentation_type: 'basic' } });
    fetchActivePeriods({ params: { group_ids: groupId, in_hierarchy: true } });
  }, []);

  const teams = useMemo(
    () =>
      groups
        .filter(group => group.type === 'team' && group.parent_group_id === groupId)
        .sort((a, b) => (a.display_order || 0) - (b.display_order || 0)),
    [groups, groupId]
  );

  const stationMemberships = useMemo(
    () =>
      memberships
        .filter(
          membership =>
            membership.group_id === groupId &&
            ['active', 'future'].includes(membership.status) &&
            usersById[membership.user_id]
        )
        .sort((a, b) => a.display_order - b.display_order),
    [memberships, groupId, usersById]
  );

  // const displayContextMenu = useCallback((event, teamId, userId) => {
  //   event.preventDefault();
  //   setShowContextMenu({
  //     xCoord: event.pageX,
  //     yCoord: event.pageY,
  //     show: true,
  //     teamId,
  //     userId
  //   });
  // }, []);

  // const showDialog = useCallback(type => {
  //   setShowDialogType(type);
  //   setShowContextMenu(prev => ({ ...prev, show: false }));
  // }, []);
  //
  // const dialogSubmit = useCallback(
  //   (time, comments) => {
  //     const { userId, teamId } = showContextMenu;
  //     const possessed = showDialogType === ASSIGN;
  //
  //     assignTeamMembership({
  //       userId,
  //       groupId: teamId,
  //       possessed,
  //       time,
  //       comments
  //     });
  //     setShowDialogType(null);
  //   },
  //   [assignTeamMembership, showContextMenu, showDialogType]
  // );

  // const closeContextMenu = useCallback(() => {
  //   setShowContextMenu(prev => ({ ...prev, show: false }));
  // }, []);

  // useEffect(() => {
  //   document.addEventListener('click', closeContextMenu);
  //   return () => {
  //     document.removeEventListener('click', closeContextMenu);
  //   };
  // }, [closeContextMenu]);

  const toggleTeamMembership = useCallback(
    (userId, teamId, possessed) => {
      return assignTeamMembership({
        userId,
        groupId: teamId,
        possessed
      });
    },
    [assignTeamMembership]
  );

  const { height } = useWindowDimensions();

  if (!loaded) return <Loader />;

  return (
    <>
      {
        // <ContextMenu
        //   xCoord={showContextMenu.xCoord}
        //   yCoord={showContextMenu.yCoord}
        //   show={showContextMenu.show}
        //   showDialog={showDialog}
        // />
        // <AssignRevokeDialog
        //   userName={usersById[showContextMenu.userId]?.full_name}
        //   teamName={teams.find(team => team.id === showContextMenu.teamId)?.name}
        //   type={showDialogType}
        //   onCancel={() => setShowDialogType(null)}
        //   onSubmit={dialogSubmit}
        // />
        //
      }
      <div className="overflow-y-scroll" style={{ maxHeight: height * 0.67 }}>
        <Table hover>
          <thead>
            <tr>
              <th className="position-sticky top-0 start-0 z-3" style={{ minWidth: '250px' }}>
                {I18n.t('fire_station.member')}
              </th>
              <th>{I18n.t('activerecord.attributes.user.skill_icons')}</th>
              {teamExchangeEnabled && <th></th>}
              {teams.map(team => (
                <th
                  key={team.id}
                  align="center"
                  className="position-sticky top-0 z-2 text-center"
                  style={{ minWidth: '120px' }}
                >
                  <a href={`/groups/${team.id}`} target="_blank" rel="noreferrer">
                    <Badge color={team.color}>{team.name}</Badge>
                  </a>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {stationMemberships.map(membership => {
              const user = usersById[membership.user_id];
              if (!user) return null;

              return (
                <tr key={membership.id}>
                  <td className="position-sticky start-0 z-1">
                    <a href={`/users/${membership.user_id}`} target="_blank" rel="noreferrer">
                      {user.full_name}
                    </a>
                  </td>
                  <td>
                    <SkillIconList skills={membership.skills} />
                  </td>
                  {teamExchangeEnabled && (
                    <td>
                      <Button
                        size="sm"
                        title={I18n.t('group_membership_exchange.short_explanation')}
                        variant="outline-secondary"
                        href={`/groups/${membership.group_id}/users/${membership.user_id}/teams`}
                      >
                        <IconShuffle />
                      </Button>
                    </td>
                  )}
                  {teams.map(team => {
                    const activePeriods =
                      (activePeriodsByUserAndGroupId[membership.user_id] || emptyObject)[team.id] || emptyArray;
                    return (
                      <td align="center" key={`membership_${membership.id}_team_${team.id}`}>
                        <TeamMembershipTableCell
                          activePeriods={activePeriods}
                          readonly={readonly}
                          onContextMenu={() => {} /*event => displayContextMenu(event, team.id, membership.user_id) */}
                          onToggle={possessed => toggleTeamMembership(membership.user_id, team.id, possessed)}
                        />
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>
    </>
  );
};

const mapStateToProps = state => ({
  groups: groupSelectors.values(state),
  memberships: Object.values(membershipSelectors.membershipsWithSkills(state)),
  usersById: userSelectors.byId(state),
  activePeriodsByUserAndGroupId: activePeriodSelectors.activePeriodsByUserAndGroupId(state),
  loaded:
    groupSelectors.initialLoadComplete(state) &&
    membershipSelectors.initialLoadComplete(state) &&
    userSelectors.initialLoadComplete(state) &&
    activePeriodSelectors.initialLoadComplete(state)
});

const mapDispatchToProps = {
  fetchMemberships: membershipOperations.fetch,
  fetchSkills: skillOperations.fetch,
  fetchUsers: userOperations.fetch,
  fetchGroups: groupOperations.fetch,
  fetchActivePeriods: activePeriodOperations.fetch,
  assignTeamMembership: activePeriodOperations.assignTeamMembership
};

export default connect(mapStateToProps, mapDispatchToProps)(TeamMembershipEditTable);
